import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	mode: "history",
	routes: [
		{
			path: "/",
			meta: {
				'title': '首页',
				'keepAlive': true,
			},
			name: "Home",
			component: () => import("../views/home.vue")
		},
		{
			path: "/login",
			meta: {
				'title': '登录',
				'keepAlive': true,
			},
			name: "Login",
			component: () => import("../views/login.vue")
		}, {
			path: "/wrong",
			meta: {
				'title': 'Wrong',
				'keepAlive': true,
			},
			name: "Wrong",
			component: () => import("../views/wrong.vue")
		},
		{
			path: "/demo",
			meta: {
				'title': 'demo',
				'keepAlive': true,
			},
			name: "Demo",
			component: () => import("../views/demo.vue")
		},
		{
			path: "/demos",
			meta: {
				'title': 'demos',
				'keepAlive': true,
			},
			name: "Demos",
			component: () => import("../views/demos.vue")
		},
		{
			path: "/articletiplist",
			meta: {
				'title': '帖子标签管理',
				'keepAlive': false,
			},
			name: "ArticleTipList",
			component: () => import("../views/feelings/articletipList.vue")
		},
		{
			path: "/articletips",
			meta: {
				'title': '帖子标签',
				'keepAlive': false,
			},
			name: "ArticleTips",
			component: () => import("../views/feelings/articleTips.vue")
		},
		{
			path: "/commentstips",
			meta: {
				'title': '评论标签',
				'keepAlive': false,
			},
			name: "CommentsTips",
			component: () => import("../views/feelings/commentsTips.vue")
		},
		{
			path: "/commentslist",
			meta: {
				'title': '汽车之家评论列表',
				'keepAlive': true,
			},
			name: "CommentsList",
			component: () => import("../views/feelings/commentsList.vue")
		},
		{
			path: "/trainlist",
			meta: {
				'title': '训练样例管理',
				'keepAlive': true,
			},
			name: "TrainList",
			component: () => import("../views/feelings/trainList.vue")
		},
		{
			path: "/speciallist",
			meta: {
				'title': '特殊名词管理',
				'keepAlive': true,
			},
			name: "SpecialList",
			component: () => import("../views/feelings/specialList.vue")
		},
		{
			path: "/monitorbbslist",
			meta: {
				'title': '监测论坛列表',
				'keepAlive': true,
			},
			name: "MonitorBbsList",
			component: () => import("../views/feelings/monitorbbsList.vue")
		}, {
			path: "/bbskeywordlist",
			meta: {
				'title': '论坛关键词',
				'keepAlive': true,
			},
			name: "BbsKeywordList",
			component: () => import("../views/bbs/bbskeywordList.vue")
		},
		{
			path: "/trainkey",
			meta: {
				'title': '训练关键词',
				'keepAlive': true,
			},
			name: "TrainKey",
			component: () => import("../views/feelings/trainKey.vue")
		},
		{
			path: "/export",
			meta: {
				'title': '舆情报告下载',
				'keepAlive': true,
			},
			name: "Export",
			component: () => import("../views/export/export.vue")
		},
		{
			path: "/exportlist",
			meta: {
				'title': '舆情下载记录',
				'keepAlive': true,
			},
			name: "ExportList",
			component: () => import("../views/export/exportList.vue")
		},
		{
			path: "/userlist",
			meta: {
				'title': 'Fans助手用户',
				'keepAlive': true,
			},
			name: "UserList",
			component: () => import("../views/member/userList.vue")
		},
		{
			path: "/activelist",
			meta: {
				'title': '招募活动管理',
				'keepAlive': true,
			},
			name: "ActiveList",
			component: () => import("../views/actived/activeList.vue")
		},
		{
			path: "/activeformword",
			meta: {
				'title': '活动表单字段',
				'keepAlive': true,
			},
			name: "ActiveFormWord",
			component: () => import("../views/actived/activeFormWord.vue")
		},
		{
			path: "/locationlist",
			meta: {
				'title': '打卡坐标',
				'keepAlive': true,
			},
			name: "LocationList",
			component: () => import("../views/actived/locationList.vue")
		},
		{
			path: "/giftlist",
			meta: {
				'title': '奖品列表',
				'keepAlive': true,
			},
			name: "GiftList",
			component: () => import("../views/actived/giftList.vue")
		},
		{
			path: "/zanlotterylist",
			meta: {
				'title': '点赞中奖名单',
				'keepAlive': true,
			},
			name: "ZanLotteryList",
			component: () => import("../views/actived/zanLotteryList.vue")
		},
		{
			path: "/activeapprovelist",
			meta: {
				'title': '活动认证管理',
				'keepAlive': true,
			},
			name: "ActiveApproveList",
			component: () => import("../views/actived/activeapproveList.vue")
		},
		{
			path: "/activeprojectslist",
			meta: {
				'title': '活动项目管理',
				'keepAlive': true,
			},
			name: "ActiveProjectsList",
			component: () => import("../views/actived/activeProjectsList.vue")
		},
		{
			path: "/activeprojectsuser",
			meta: {
				'title': '活动项目用户',
				'keepAlive': true,
			},
			name: "ActiveProjectsUser",
			component: () => import("../views/actived/activeProjectsUser.vue")
		},
		{
			path: "/baiduuserlist",
			meta: {
				'title': '百度用户',
				'keepAlive': true,
			},
			name: "BaiduUserList",
			component: () => import("../views/member/baiduuserList.vue")
		},
		{
			path: "/toutuserlist",
			meta: {
				'title': '头条用户',
				'keepAlive': true,
			},
			name: "ToutUserList",
			component: () => import("../views/member/toutuserList.vue")
		},
		{
			path: "/tiktokuserlist",
			meta: {
				'title': '抖音用户',
				'keepAlive': true,
			},
			name: "TiktokUserList",
			component: () => import("../views/member/tiktokuserList.vue")
		},
		{
			path: "/motoruserlist",
			meta: {
				'title': '汽车时间用户',
				'keepAlive': true,
			},
			name: "MotorUserList",
			component: () => import("../views/member/motoruserList.vue")
		},

		{
			path: "/motoruserinfo",
			meta: {
				'title': '汽车时间用户详情',
				'keepAlive': true,
			},
			name: "MotorUserInfo",
			component: () => import("../views/member/motoruserInfo.vue")
		},
		{
			path: "/carsuserlist",
			meta: {
				'title': '汽车之家用户列表',
				'keepAlive': true,
			},
			name: "CarsUserList",
			component: () => import("../views/member/carsuserList.vue")
		},

		{
			path: "/articlelist",
			meta: {
				'title': '监测相似文章列表',
				'keepAlive': true,
			},
			name: "ArticleListLike",
			component: () => import("../views/likearticle/articleList.vue")
		}, {
			path: "/articlelike",
			meta: {
				'title': '相似文章',
				'keepAlive': true,
			},
			name: "ArticleLike",
			component: () => import("../views/likearticle/articleLike.vue")
		}, {
			path: "/commentlike",
			meta: {
				'title': '相似评论',
				'keepAlive': true,
			},
			name: "CommentLike",
			component: () => import("../views/likearticle/commentLike.vue")
		}, {
			path: "/treelist",
			meta: {
				'title': '菜单列表',
				'keepAlive': true,
			},
			name: "TreeList",
			component: () => import("../views/tree/treeList.vue")
		}, {
			path: "/adminlist",
			meta: {
				'title': '管理员列表',
				'keepAlive': true,
			},
			name: "AdminList",
			component: () => import("../views/tree/adminList.vue")
		}, {
			path: "/grouplist",
			meta: {
				'title': '车友群列表',
				'keepAlive': true,
			},
			name: "GroupList",
			component: () => import("../views/group/groupList.vue")
		}, {
			path: "/groupinfo",
			meta: {
				'title': '客服管理',
				'keepAlive': true,
			},
			name: "GroupInfo",
			component: () => import("../views/group/groupInfo.vue")
		},
		{
			path: "/groupswitch",
			meta: {
				'title': '车友群开关',
				'keepAlive': true,
			},
			name: "GroupSwitch",
			component: () => import("../views/group/groupSwitch.vue")
		},
		{
			path: "/wechatgrouplist",
			meta: {
				'title': '微信群列表',
				'keepAlive': true,
			},
			name: "WechatGroupList",
			component: () => import("../views/group/wechatGroupList.vue")
		}, {
			path: "/wechatuserlist",
			meta: {
				'title': '微信群联系人',
				'keepAlive': true,
			},
			name: "WechatUserList",
			component: () => import("../views/group/wechatuserList.vue")
		}, {
			path: "/wechatmessagelist",
			meta: {
				'title': '微信群聊记录',
				'keepAlive': true,
			},
			name: "WechatMessageList",
			component: () => import("../views/group/wechatMessageList.vue")
		}, {
			path: "/livelist",
			meta: {
				'title': '直播列表',
				'keepAlive': true,
			},
			name: "LiveList",
			component: () => import("../views/live/liveList.vue")
		}, {
			path: "/livecomment",
			meta: {
				'title': '直播评论',
				'keepAlive': true,
			},
			name: "LiveComment",
			component: () => import("../views/live/liveComment.vue")
		}, {
			path: "/targetlist",
			meta: {
				'title': '采集关键词列表',
				'keepAlive': true,
			},
			name: "TargetList",
			component: () => import("../views/keyword/targetList.vue")
		}, {
			path: "/gatherlist",
			meta: {
				'title': '采集目标列表',
				'keepAlive': true,
			},
			name: "GatherList",
			component: () => import("../views/keyword/gatherList.vue")
		}, {
			path: "/keyinfo",
			meta: {
				'title': '采集详情',
				'keepAlive': true,
			},
			name: "KeyInfo",
			component: () => import("../views/keyword/keyInfo.vue")
		}, {
			path: "/keyuserinfo",
			meta: {
				'title': '用户采集详情',
				'keepAlive': true,
			},
			name: "KeyUserInfo",
			component: () => import("../views/keyword/keyUserInfo.vue")
		}, {
			path: "/keysearch",
			meta: {
				'title': '关键词采集',
				'keepAlive': true,
			},
			name: "KeySearch",
			component: () => import("../views/keyword/keySearch.vue")
		}, {
			path: "/keysearchinfo",
			meta: {
				'title': '搜索详情',
				'keepAlive': true,
			},
			name: "KeySearchInfo",
			component: () => import("../views/keyword/keySearchInfo.vue")
		}, {
			path: "/ptarticlekeyword",
			meta: {
				'title': '平台文章关键词',
				'keepAlive': true,
			},
			name: "ptArticleKeyword",
			component: () => import("../views/keyword/ptArticleKeyword.vue")
		}, {
			path: "/mattercompany",
			meta: {
				'title': '公司列表',
				'keepAlive': true,
			},
			name: "MatterCompany",
			component: () => import("../views/matter/matterCompany.vue")
		}, {
			path: "/mattercompanyimg",
			meta: {
				'title': '图片列表',
				'keepAlive': true,
			},
			name: "MatterCompanyImg",
			component: () => import("../views/matter/matterCompanyImg.vue")
		}, {
			path: "/mattercompanyart",
			meta: {
				'title': '公司文章',
				'keepAlive': true,
			},
			name: "MatterCompanyArt",
			component: () => import("../views/matter/matterCompanyArt.vue")
		}, {
			path: "/mattersource",
			meta: {
				'title': '平台列表',
				'keepAlive': true,
			},
			name: "MatterSource",
			component: () => import("../views/matter/matterSource.vue")
		}, {
			path: "/matterimg",
			meta: {
				'title': '素材库图库列表',
				'keepAlive': true,
			},
			name: "MatterImg",
			component: () => import("../views/matter/matterImg.vue")
		}, {
			path: "/mattermonitor",
			meta: {
				'title': '监测文章列表',
				'keepAlive': true,
			},
			name: "MatterMonitor",
			component: () => import("../views/matter/matterMonitor.vue")
		}, {
			path: "/mattertips",
			meta: {
				'title': '图片打标签',
				'keepAlive': true,
			},
			name: "MatterTips",
			component: () => import("../views/matter/matterTips.vue")
		}, {
			path: "/mattersourceimg",
			meta: {
				'title': '图片列表',
				'keepAlive': true,
			},
			name: "MatterSourceImg",
			component: () => import("../views/matter/matterSourceImg.vue")
		}, {
			path: "/mattersourceart",
			meta: {
				'title': '平台文章',
				'keepAlive': true,
			},
			name: "MatterSourceArt",
			component: () => import("../views/matter/matterSourceArt.vue")
		}, {
			path: "/matterimgiart",
			meta: {
				'title': '图库文章',
				'keepAlive': true,
			},
			name: "MatterImgArt",
			component: () => import("../views/matter/matterImgArt.vue")
		}, {
			path: "/matterexport",
			meta: {
				'title': '监测报告下载',
				'keepAlive': true,
			},
			name: "MatterExport",
			component: () => import("../views/matter/matterExport.vue")
		}, {
			path: "/matterexportlist",
			meta: {
				'title': '监测报告下载列表',
				'keepAlive': true,
			},
			name: "MatterExportList",
			component: () => import("../views/matter/matterExportList.vue")
		}, {
			path: "/matterarticlelist",
			meta: {
				'title': '素材库文章模板列表',
				'keepAlive': true,
			},
			name: "MatterArticleList",
			component: () => import("../views/matter/matterArticleList.vue")
		}, {
			path: "/matterarticleart",
			meta: {
				'title': '关联文章列表',
				'keepAlive': true,
			},
			name: "MatterArticleArt",
			component: () => import("../views/matter/matterArticleArt.vue")
		},
		{
			path: "/matterlist",
			meta: {
				'title': '文章图片列表',
				'keepAlive': true,
			},
			name: "MatterList",
			component: () => import("../views/matter/matterList.vue")
		}, {
			path: "/matterlistd",
			meta: {
				'title': '文章图片筛选列表',
				'keepAlive': true,
			},
			name: "MatterListd",
			component: () => import("../views/matter/matterListd.vue")
		}, {
			path: "/matterlisttag",
			meta: {
				'title': '文章图片打标签',
				'keepAlive': true,
			},
			name: "MatterListTag",
			component: () => import("../views/matter/matterListTag.vue")
		}, {
			path: "/mattermessage",
			meta: {
				'title': '素材库消息',
				'keepAlive': true,
			},
			name: "MatterMessage",
			component: () => import("../views/matter/matterMessage.vue")
		}, {
			path: "/matterredlist",
			meta: {
				'title': '小红书监测列表',
				'keepAlive': false,
			},
			name: "MatterRedList",
			component: () => import("../views/matter/matterRedList.vue")
		}, {
			path: "/companyuserlist",
			meta: {
				'title': '经销商员工列表',
				'keepAlive': false,
			},
			name: "CompanyUserList",
			component: () => import("../views/matter/companyUserList.vue")
		}, {
			path: "/shop/brandlist",
			meta: {
				'title': '商城品牌管理',
				'keepAlive': false,
			},
			name: "BrandList",
			component: () => import("../views/shops/brandList.vue")
		}, {
			path: "/shop/brandtiplist",
			meta: {
				'title': '商品标签管理',
				'keepAlive': false,
			},
			name: "BrandTipList",
			component: () => import("../views/shops/brandtipList.vue")
		}, {
			path: "/shop/shopactivelist",
			meta: {
				'title': '商城活动管理',
				'keepAlive': false,
			},
			name: "ShopActiveList",
			component: () => import("../views/shops/shopactiveList.vue")
		}, {
			path: "/shop/classlist",
			meta: {
				'title': '商城商品分类管理',
				'keepAlive': false,
			},
			name: "ClassList",
			component: () => import("../views/shops/classList.vue")
		}, {
			path: "/shop/columnlist",
			meta: {
				'title': '商城板块管理',
				'keepAlive': false,
			},
			name: "ColumnList",
			component: () => import("../views/shops/columnList.vue")
		}, {
			path: "/shop/columnclasslist",
			meta: {
				'title': '商品类别管理',
				'keepAlive': false,
			},
			name: "ColumnClassList",
			component: () => import("../views/shops/columnclassList.vue")
		}, {
			path: "/shop/columnchildlist",
			meta: {
				'title': '商品类别子类管理',
				'keepAlive': false,
			},
			name: "ColumnChildList",
			component: () => import("../views/shops/columnchildList.vue")
		}, {
			path: "/shop/orderlist",
			meta: {
				'title': '订单列表',
				'keepAlive': false,
			},
			name: "OrderList",
			component: () => import("../views/shops/orderList.vue")
		}, {
			path: "/shop/refundlist",
			meta: {
				'title': '退款管理',
				'keepAlive': false,
			},
			name: "RefundList",
			component: () => import("../views/shops/refundList.vue")
		}, {
			path: "/shop/goodslist",
			meta: {
				'title': '商品管理',
				'keepAlive': false,
			},
			name: "GoodsList",
			component: () => import("../views/shops/goodsList.vue")
		}, {
			path: "/shop/logistics",
			meta: {
				'title': '物流系统',
				'keepAlive': false,
			},
			name: "Logistics",
			component: () => import("../views/shops/logistics.vue")
		}, {
			path: "/shop/statistics",
			meta: {
				'title': '数据统计金额',
				'keepAlive': false,
			},
			name: "Statistics",
			component: () => import("../views/shops/statistics.vue")
		}, {
			path: "/shop/costlist",
			meta: {
				'title': '商品成本列表',
				'keepAlive': false,
			},
			name: "CostList",
			component: () => import("../views/shops/costList.vue")
		}, {
			path: "/shop/salestargetlist",
			meta: {
				'title': '商品预估销售目标',
				'keepAlive': false,
			},
			name: "SalesTargetList",
			component: () => import("../views/shops/salesTargetList.vue")
		},
		{
			path: "/shop/salelist",
			meta: {
				'title': '优惠政策明细',
				'keepAlive': false,
			},
			name: "SaleList",
			component: () => import("../views/shops/saleList.vue")
		},
		{
			path: "/shop/salegoodslist",
			meta: {
				'title': '返利商品管理',
				'keepAlive': false,
			},
			name: "SaleGoodsList",
			component: () => import("../views/shops/saleGoodsList.vue")
		},
		{
			path: "/shop/saleuserlist",
			meta: {
				'title': '带货达人用户',
				'keepAlive': false,
			},
			name: "SaleUserList",
			component: () => import("../views/shops/saleUserList.vue")
		},
		{
			path: "/shop/salebindlist",
			meta: {
				'title': '绑定商品列表',
				'keepAlive': false,
			},
			name: "SaleBindList",
			component: () => import("../views/shops/saleBindList.vue")
		},
		{
			path: "/shop/salesorderlist",
			meta: {
				'title': '返利订单列表',
				'keepAlive': false,
			},
			name: "SalesOrderList",
			component: () => import("../views/shops/salesOrderList.vue")
		},
		{
			path: "/shop/attrstypelist",
			meta: {
				'title': '商品属性',
				'keepAlive': false,
			},
			name: "AttrsTypeList",
			component: () => import("../views/shops/attrsTypeList.vue")
		},
		{
			path: "/bbslist",
			meta: {
				'title': '论坛列表',
				'keepAlive': false,
			},
			name: "BbsList",
			component: () => import("../views/bbs/bbsList.vue")
		},
		{
			path: "/taglist",
			meta: {
				'title': '标签列表',
				'keepAlive': false,
			},
			name: "TagList",
			component: () => import("../views/bbs/tagList.vue")
		},
		{
			path: "/cardlist",
			meta: {
				'title': '帖子管理',
				'keepAlive': false,
			},
			name: "CardList",
			component: () => import("../views/bbs/cardList.vue")
		},
		{
			path: "/commentlist",
			meta: {
				'title': '帖子评论管理',
				'keepAlive': false,
			},
			name: "CommentList",
			component: () => import("../views/bbs/commentList.vue")
		},
		{
			path: "/topictype",
			meta: {
				'title': '话题类型',
				'keepAlive': false,
			},
			name: "TopicType",
			component: () => import("../views/bbs/topicType.vue")
		},
		{
			path: "/topiclist",
			meta: {
				'title': '话题列表',
				'keepAlive': false,
			},
			name: "TopicList",
			component: () => import("../views/bbs/topicList.vue")
		},
		{
			path: "/article/articlelist",
			meta: {
				'title': '文章列表',
				'keepAlive': false,
			},
			name: "ArticleList",
			component: () => import("../views/article/articleList.vue")
		}, {
			path: "/article/picturelist",
			meta: {
				'title': '图集列表',
				'keepAlive': false,
			},
			name: "PictureList",
			component: () => import("../views/article/pictureList.vue")
		},
		{
			path: "/article/articlecomment",
			meta: {
				'title': '文章评论管理',
				'keepAlive': false,
			},
			name: "ArticleComment",
			component: () => import("../views/article/articleComment.vue")
		}, {
			path: "/article/videolist",
			meta: {
				'title': '上传视频',
				'keepAlive': false,
			},
			name: "VideoList",
			component: () => import("../views/article/videoList.vue")
		}, {
			path: "/article/ptindexarticle",
			meta: {
				'title': '平台首页推荐文章',
				'keepAlive': false,
			},
			name: "ptIndexArticle",
			component: () => import("../views/article/ptIndexArticle.vue")
		}, {
			path: "/article/ptarticlecomment",
			meta: {
				'title': '推荐文章评论列表',
				'keepAlive': false,
			},
			name: "pyArticleComment",
			component: () => import("../views/article/ptArticleComment.vue")
		}, {
			path: "/article/headlineslist",
			meta: {
				'title': 'pc头条列表',
				'keepAlive': true,
			},
			name: "HeadlinesList",
			component: () => import("../views/article/headlinesList.vue")
		}, {
			path: "/article/newslist",
			meta: {
				'title': 'pc新闻列表',
				'keepAlive': true,
			},
			name: "NewsList",
			component: () => import("../views/article/newsList.vue")
		}, {
			path: "/article/positionlist",
			meta: {
				'title': 'pc位置推荐列表',
				'keepAlive': true,
			},
			name: "PositionList",
			component: () => import("../views/article/positionList.vue")
		}, {
			path: "/votelist",
			meta: {
				'title': '问卷列表',
				'keepAlive': true,
			},
			name: "VoteList",
			component: () => import("../views/vote/voteList.vue")
		},
		{
			path: "/votequeslist",
			meta: {
				'title': '问卷问题列表',
				'keepAlive': true,
			},
			name: "VoteQuesList",
			component: () => import("../views/vote/voteQuesList.vue")
		}, {
			path: "/datamonitor",
			meta: {
				'title': '数据监测',
				'keepAlive': true,
			},
			name: "DataMonitor",
			component: () => import("../views/statistics/dataMonitor.vue")
		}, {
			path: "/statlist",
			meta: {
				'title': '统计列表',
				'keepAlive': true,
			},
			name: "StatList",
			component: () => import("../views/statistics/statList.vue")
		}, {
			path: "/versionlist",
			meta: {
				'title': 'App版本管理',
				'keepAlive': true,
			},
			name: "VersionList",
			component: () => import("../views/center/versionList.vue")
		}, {
			path: "/advlist",
			meta: {
				'title': '广告管理',
				'keepAlive': true,
			},
			name: "AdvList",
			component: () => import("../views/center/advList.vue")
		}, {
			path: "/pathlist",
			meta: {
				'title': '页面管理',
				'keepAlive': true,
			},
			name: "PathList",
			component: () => import("../views/center/pathList.vue")
		}, {
			path: "/channellist",
			meta: {
				'title': '频道管理',
				'keepAlive': true,
			},
			name: "ChannelList",
			component: () => import("../views/center/channelList.vue")
		}, {
			path: "/medialist",
			meta: {
				'title': '媒体来源',
				'keepAlive': true,
			},
			name: "MediaList",
			component: () => import("../views/center/mediaList.vue")
		}, {
			path: "/mediacolumnlist",
			meta: {
				'title': '媒体栏目管理',
				'keepAlive': true,
			},
			name: "MediaColumnList",
			component: () => import("../views/center/mediacolumnList.vue")
		}, {
			path: "/acolumnlist",
			meta: {
				'title': '栏目管理',
				'keepAlive': true,
			},
			name: "AColumnList",
			component: () => import("../views/center/acolumnList.vue")
		}, {
			path: "/maclist",
			meta: {
				'title': 'MAC管理',
				'keepAlive': true,
			},
			name: "MACList",
			component: () => import("../views/center/macList.vue")
		}, {
			path: "/fansdatalist",
			meta: {
				'title': '数据监测',
				'keepAlive': true,
			},
			name: "FansDataList",
			component: () => import("../views/fansdata/fansDataList.vue")
		}, {
			path: "/fansdatainfo",
			meta: {
				'title': '数据监测',
				'keepAlive': true,
			},
			name: "FansDataInfo",
			component: () => import("../views/fansdata/fansDataInfo.vue")
		},
		{
			path: "/messagelist",
			meta: {
				'title': '舆情消息管理',
				'keepAlive': true,
			},
			name: "MessageList",
			component: () => import("../views/message/mesageList.vue")
		},
		{
			path: "/sysmessagelist",
			meta: {
				'title': '系统消息管理',
				'keepAlive': true,
			},
			name: "SysMessageList",
			component: () => import("../views/message/sysmesageList.vue")
		},
		{
			path: "/applymessagelist",
			meta: {
				'title': '应用消息管理',
				'keepAlive': true,
			},
			name: "ApplyMessageList",
			component: () => import("../views/message/applymesageList.vue")
		},
		{
			path: "/honormedal",
			meta: {
				'title': '勋章体系管理',
				'keepAlive': true,
			},
			name: "HonorMedal",
			component: () => import("../views/honor/honorMedal.vue")
		},
		{
			path: "/honorlist",
			meta: {
				'title': '勋章管理',
				'keepAlive': true,
			},
			name: "HonorList",
			component: () => import("../views/honor/honorList.vue")
		},
		{
			path: "/honortasklist",
			meta: {
				'title': '任务列表',
				'keepAlive': true,
			},
			name: "HonorTaskList",
			component: () => import("../views/honor/honorTaskList.vue")
		},
		{
			path: "/tasklist",
			meta: {
				'title': '任务体系',
				'keepAlive': true,
			},
			name: "TaskList",
			component: () => import("../views/honor/taskList.vue")
		},
		{
			path: "/questionchannel",
			meta: {
				'title': '问答频道',
				'keepAlive': true,
			},
			name: "QuestionChannel",
			component: () => import("../views/question/questionChannel.vue")
		},
		{
			path: "/questioncolumn",
			meta: {
				'title': '问答栏目',
				'keepAlive': true,
			},
			name: "QuestionColumn",
			component: () => import("../views/question/questionColumn.vue")
		},
		{
			path: "/questionlist",
			meta: {
				'title': '问题列表',
				'keepAlive': true,
			},
			name: "QuestionList",
			component: () => import("../views/question/questionList.vue")
		},

		{
			path: "/answerlist",
			meta: {
				'title': '答案列表',
				'keepAlive': true,
			},
			name: "AnswerList",
			component: () => import("../views/question/answerList.vue")
		},
		{
			path: "/answercommentlist",
			meta: {
				'title': '评论列表',
				'keepAlive': true,
			},
			name: "AnswerCommentList",
			component: () => import("../views/question/answerCommentList.vue")
		}, {
			path: "/carbrandslist",
			meta: {
				'title': '车品牌管理',
				'keepAlive': true,
			},
			name: "CarBrandsList",
			component: () => import("../views/cars/carBrandsList.vue")
		}, {
			path: "/carslist",
			meta: {
				'title': '车系管理',
				'keepAlive': true,
			},
			name: "CarsList",
			component: () => import("../views/cars/carsList.vue")
		}, {
			path: "/careralist",
			meta: {
				'title': '代系管理',
				'keepAlive': true,
			},
			name: "CarEraList",
			component: () => import("../views/cars/carEraList.vue")
		}, {
			path: "/carmodelslist",
			meta: {
				'title': '车型管理',
				'keepAlive': true,
			},
			name: "CarModelsList",
			component: () => import("../views/cars/carModelsList.vue")
		}, {
			path: "/carchannellist",
			meta: {
				'title': '车型库频道',
				'keepAlive': true,
			},
			name: "CarChannelList",
			component: () => import("../views/cars/carChannelList.vue")
		}, {
			path: "/carcolumnlist",
			meta: {
				'title': '车型库栏目',
				'keepAlive': true,
			},
			name: "CarColumnList",
			component: () => import("../views/cars/carColumnList.vue")
		}, {
			path: "/carvideolist",
			meta: {
				'title': '车型库视频',
				'keepAlive': true,
			},
			name: "CarVideoList",
			component: () => import("../views/cars/carVideoList.vue")
		}, {
			path: "/caruserapprove",
			meta: {
				'title': '车主认证审核',
				'keepAlive': true,
			},
			name: "CarUserApprove",
			component: () => import("../views/cars/carUserApprove.vue")
		}, {
			path: "/qalist",
			meta: {
				'title': '答题列表',
				'keepAlive': true,
			},
			name: "QAList",
			component: () => import("../views/qa/qaList.vue")
		}, {
			path: "/qaphaselist",
			meta: {
				'title': '答题阶段',
				'keepAlive': true,
			},
			name: "QAPhaseList",
			component: () => import("../views/qa/qaPhaseList.vue")
		}, {
			path: "/seasonlist",
			meta: {
				'title': '答题赛季',
				'keepAlive': true,
			},
			name: "QASeasonList",
			component: () => import("../views/qa/seasonList.vue")
		},
		{
			path: "/qaqueslist",
			meta: {
				'title': '答题问题列表',
				'keepAlive': true,
			},
			name: "QAQuesList",
			component: () => import("../views/qa/qaquesList.vue")
		}, {
			path: "/qarecordlist",
			meta: {
				'title': '答题记录',
				'keepAlive': true,
			},
			name: "QARecordList",
			component: () => import("../views/qa/qarecordList.vue")
		},
		{
			path: "/subaru/subarudealerslist",
			meta: {
				'title': '斯巴鲁经销商管理',
				'keepAlive': true,
			},
			name: "SubaruDealersList",
			component: () => import("../views/dealers/subaruDealersList.vue")
		}, {
			path: "/subaru/subarudealersman",
			meta: {
				'title': '斯巴鲁员工管理',
				'keepAlive': true,
			},
			name: "SubaruDealersMan",
			component: () => import("../views/dealers/subaruDealersMan.vue")
		},
		{
			path: "/toyota/kartinglist",
			meta: {
				'title': '卡丁车场',
				'keepAlive': true,
			},
			name: "KartingList",
			component: () => import("../views/toyota/kartingList.vue")
		}, {
			path: "/toyota/kartingactivelist",
			meta: {
				'title': '卡丁车竞速活动',
				'keepAlive': true,
			},
			name: "KartingActiveList",
			component: () => import("../views/toyota/kartingActiveList.vue")
		}, {
			path: "/toyota/kartingactiveapprove",
			meta: {
				'title': 'GR活动审核列表',
				'keepAlive': true,
			},
			name: "KartingActiveApprove",
			component: () => import("../views/toyota/kartingActiveApprove.vue")
		},
		{
			path: "/toyota/kartinggiftlist",
			meta: {
				'title': '卡丁车奖品',
				'keepAlive': true,
			},
			name: "KartingGiftList",
			component: () => import("../views/toyota/kartingGiftList.vue")
		}, {
			path: "/toyota/toyotadealerslist",
			meta: {
				'title': '丰田4S店列表',
				'keepAlive': true,
			},
			name: "ToyotaDealersList",
			component: () => import("../views/toyota/toyotaDealersList.vue")
		}, {
			path: "/toyota/toyotadealersman",
			meta: {
				'title': '丰田员工',
				'keepAlive': true,
			},
			name: "ToyotaDealersMan",
			component: () => import("../views/toyota/toyotaDealersMan.vue")
		}, {
			path: "/dmcmessage",
			meta: {
				'title': '素材库消息通知',
				'keepAlive': true,
			},
			name: "DmcMessage",
			component: () => import("../views/message/dmcMessage.vue")
		}, {
			path: "/dmcposterlist",
			meta: {
				'title': 'DMC海报管理',
				'keepAlive': true,
			},
			name: "DmcPosterList",
			component: () => import("../views/dmc/dmcPosterList.vue")
		}, {
			path: "/dmctextlist",
			meta: {
				'title': '海报文案管理',
				'keepAlive': true,
			},
			name: "DmcTextList",
			component: () => import("../views/dmc/dmcTextList.vue")
		}, {
			path: "/dmcimglist",
			meta: {
				'title': '海报图片管理',
				'keepAlive': true,
			},
			name: "DmcImgList",
			component: () => import("../views/dmc/dmcImgList.vue")
		}, {
			path: "/dmcsolarimglist",
			meta: {
				'title': '节气海报图片管理',
				'keepAlive': true,
			},
			name: "DmcSolarImgList",
			component: () => import("../views/dmc/dmcSolarImgList.vue")
		}, {
			path: "/dmctemplist",
			meta: {
				'title': '海报模板管理',
				'keepAlive': true,
			},
			name: "DmcTempList",
			component: () => import("../views/dmc/dmcTempList.vue")
		}, {
			path: "/dmccompanylist",
			meta: {
				'title': '经销商信息管理',
				'keepAlive': true,
			},
			name: "DmcCompanyList",
			component: () => import("../views/dmc/dmcCompanyList.vue")
		}, {
			path: "/dmccompanyuserlist",
			meta: {
				'title': '经销商员工管理',
				'keepAlive': true,
			},
			name: "DmcCompanyUserList",
			component: () => import("../views/dmc/dmcCompanyUserList.vue")
		}, {
			path: "/dmcusedatalist",
			meta: {
				'title': '经销商使用数据',
				'keepAlive': true,
			},
			name: "DmcUseDataList",
			component: () => import("../views/dmc/dmcUseDataList.vue")
		},
		{
			path: "/chatgpttype",
			meta: {
				'title': '问题类型',
				'keepAlive': true,
			},
			name: "ChatgptType",
			component: () => import("../views/chatgpt/chatgptType.vue")
		},
		{
			path: "/chatgptchildtype",
			meta: {
				'title': '问题子类',
				'keepAlive': true,
			},
			name: "ChatgptChildType",
			component: () => import("../views/chatgpt/chatgptChildType.vue")
		}, {
			path: "/chatgptlist",
			meta: {
				'title': '问题列表 ',
				'keepAlive': true,
			},
			name: "ChatgptList",
			component: () => import("../views/chatgpt/chatgptList.vue")
		},
		{
			path: "/chatgptask",
			meta: {
				'title': '向chatGPT提问',
				'keepAlive': true,
			},
			name: "ChatgptAsk",
			component: () => import("../views/chatgpt/chatgptAsk.vue")
		},
		{
			path: "/chatglmlist",
			meta: {
				'title': 'chatGLM问题列表 ',
				'keepAlive': true,
			},
			name: "ChatglmList",
			component: () => import("../views/chatgpt/chatglmList.vue")
		},
		{
			path: "/chatglmask",
			meta: {
				'title': '向chatGLM提问',
				'keepAlive': true,
			},
			name: "ChatglmAsk",
			component: () => import("../views/chatgpt/chatglmAsk.vue")
		},
		{
			path: "/usergrouplist",
			meta: {
				'title': '用户组列表',
				'keepAlive': true,
			},
			name: "UserGroupList",
			component: () => import("../views/chatgpt/userGroupList.vue")
		},
		{
			path: "/shop/shopusercashlist",
			meta: {
				'title': '用户提现列表',
				'keepAlive': true,
			},
			name: "ShopuserCashList",
			component: () => import("../views/shops/shopusercashList.vue")
		},
		{
			path: "/lexusshop/scenelist",
			meta: {
				'title': '场景管理',
				'keepAlive': true,
			},
			name: "LexusShopSceneList",
			component: () => import("../views/lexusshop/sceneList.vue")
		},
		{
			path: "/lexusshop/locationlist",
			meta: {
				'title': '位置管理',
				'keepAlive': true,
			},
			name: "LexusShopLocationList",
			component: () => import("../views/lexusshop/locationList.vue")
		},
		{
			path: "/lexusshop/typelist",
			meta: {
				'title': '类型管理',
				'keepAlive': true,
			},
			name: "LexusShopTypeList",
			component: () => import("../views/lexusshop/typeList.vue")
		},
		{
			path: "/lexusshop/customtypelist",
			meta: {
				'title': '自定义类型管理',
				'keepAlive': true,
			},
			name: "LexusShopCustomTypeList",
			component: () => import("../views/lexusshop/customtypeList.vue")
		},
		{
			path: "/lexusshop/goodslist",
			meta: {
				'title': '商品内容管理',
				'keepAlive': true,
			},
			name: "LexusShopGoodsList",
			component: () => import("../views/lexusshop/goodsList.vue")
		},
		{
			path: "/agreementlist",
			meta: {
				'title': '协议管理',
				'keepAlive': true,
			},
			name: "AgreementList",
			component: () => import("../views/actived/agreementList.vue")
		},
		{
			path: "/activeauhulist",
			meta: {
				'title': '傲虎旷野版活动',
				'keepAlive': true,
			},
			name: "ActiveAuhuList",
			component: () => import("../views/actived/activeauhuList.vue")
		},
		{
			path: "/activestiapprove",
			meta: {
				'title': 'STI活动审核',
				'keepAlive': true,
			},
			name: "ActiveStiApprove",
			component: () => import("../views/actived/activeStiApprove.vue")
		},
		{
			path: "/subaruclub/clublist",
			meta: {
				'title': '车友会管理',
				'keepAlive': true,
			},
			name: "SubaruClubList",
			component: () => import("../views/subaruclub/clubList.vue")
		},
		{
			path: "/subaruclub/clubhomehanner",
			meta: {
				'title': '首页banner管理',
				'keepAlive': true,
			},
			name: "SubaruClubHomeBanner",
			component: () => import("../views/subaruclub/clubHomeBanner.vue")
		}, {
			path: "/subaruclub/clubhomeswiper",
			meta: {
				'title': '首页轮播管理',
				'keepAlive': true,
			},
			name: "SubaruClubHomeSwiper",
			component: () => import("../views/subaruclub/clubHomeSwiper.vue")
		}, {
			path: "/subaruclub/clubuserlist",
			meta: {
				'title': '车友会用户管理',
				'keepAlive': true,
			},
			name: "SubaruClubUserList",
			component: () => import("../views/subaruclub/clubUserList.vue")
		}, {
			path: "/subaruclub/clubgiftlist",
			meta: {
				'title': '车友会签到礼物管理',
				'keepAlive': true,
			},
			name: "SubaruClubGiftList",
			component: () => import("../views/subaruclub/clubGiftList.vue")
		}, {
			path: "/subaruclub/clubsigninlist",
			meta: {
				'title': '车友会签到管理',
				'keepAlive': true,
			},
			name: "SubaruClubSigninList",
			component: () => import("../views/subaruclub/clubSigninList.vue")
		}, {
			path: "/subaruclub/clubavatarborderlist",
			meta: {
				'title': '车友会用户头像框管理',
				'keepAlive': true,
			},
			name: "SubaruClubAvatarBorderList",
			component: () => import("../views/subaruclub/clubAvatarBorderList.vue")
		}, {
			path: "/yq/setting",
			meta: {
				'title': '舆情参数配置管理',
				'keepAlive': true,
			},
			name: "YqSetting",
			component: () => import("../views/yq/setting.vue")
		}, {
			path: "/yq/keyword",
			meta: {
				'title': '舆情关键词管理',
				'keepAlive': true,
			},
			name: "YqKeyword",
			component: () => import("../views/yq/keyword.vue")
		}, {
			path: "/yq/task",
			meta: {
				'title': '舆情任务管理',
				'keepAlive': true,
			},
			name: "YqTask",
			component: () => import("../views/yq/task.vue")
		}, {
			path: "/yq/toutiao/users",
			meta: {
				'title': '今日头条用户列表',
				'keepAlive': true,
			},
			name: "YqToutiaoUserList",
			component: () => import("../views/yq/user.vue"),
			props: { source: 2 }
		}, {
			path: "/yq/toutiao/comments",
			meta: {
				'title': '今日头条评论列表',
				'keepAlive': true,
			},
			name: "YqToutiaoCommentList",
			component: () => import("../views/yq/comment.vue"),
			props: { source: 2 }
		}, {
			path: "/yq/toutiao/contents",
			meta: {
				'title': '今日头条内容标签管理',
				'keepAlive': true,
			},
			name: "YqToutiaoContentList",
			component: () => import("../views/yq/content.vue"),
			props: { source: 2 }
		}, {
			path: "/yq/toutiao/content/:id/tips",
			meta: {
				'title': '今日头条内容标签管理',
				'keepAlive': true,
			},
			name: "YqToutiaoContentTips",
			component: () => import("../views/yq/info.vue"),
			props: { source: 2 }
		}, {
			path: "/yq/weibo/users",
			meta: {
				'title': '微博用户列表',
				'keepAlive': true,
			},
			name: "YqWeiboUserList",
			component: () => import("../views/yq/user.vue"),
			props: { source: 5 }
		}, {
			path: "/yq/weibo/comments",
			meta: {
				'title': '微博评论列表',
				'keepAlive': true,
			},
			name: "YqWeiboCommentList",
			component: () => import("../views/yq/comment.vue"),
			props: { source: 5 }
		}, {
			path: "/yq/weibo/contents",
			meta: {
				'title': '微博内容标签管理',
				'keepAlive': true,
			},
			name: "YqWeiboContentList",
			component: () => import("../views/yq/content.vue"),
			props: { source: 5 }
		}, {
			path: "/yq/weibo/content/:id/tips",
			meta: {
				'title': '微博内容标签管理',
				'keepAlive': true,
			},
			name: "YqWeiboContentTips",
			component: () => import("../views/yq/info.vue"),
			props: { source: 5 }
		}, {
			path: "/subaruclub/clubcardslist",
			meta: {
				'title': '车友会帖子管理',
				'keepAlive': true,
			},
			name: "SubaruClubCardsList",
			component: () => import("../views/subaruclub/clubCardsList.vue")
		}, {
			path: "/subaruclub/clubuserauditlist",
			meta: {
				'title': '车友会用户审核管理',
				'keepAlive': true,
			},
			name: "SubaruClubUserAuditList",
			component: () => import("../views/subaruclub/clubUserAuditList.vue")
		}, {
			path: "/subaruclub/clubinfoauditlist",
			meta: {
				'title': '车友会信息审核管理',
				'keepAlive': true,
			},
			name: "SubaruClubInfoAuditList",
			component: () => import("../views/subaruclub/clubInfoAuditList.vue")
		}, {
			path: "/subaruclub/clubactivelist",
			meta: {
				'title': '车友会活动管理',
				'keepAlive': true,
			},
			name: "SubaruClubActiveList",
			component: () => import("../views/subaruclub/clubActiveList.vue")
		}, {
			path: "/subaruclub/clubActiveApproveList",
			meta: {
				'title': '车友会活动报名审核',
				'keepAlive': true,
			},
			name: "SubaruClubActiveApproveList",
			component: () => import("../views/subaruclub/clubActiveApproveList.vue")
		}, {
			path: "/subaruclub/clubActiveRefundList",
			meta: {
				'title': '车友会活动报名退款',
				'keepAlive': true,
			},
			name: "SubaruClubActiveRefundList",
			component: () => import("../views/subaruclub/clubActiveRefundList.vue")
		}, {
			path: "/integral/tasklist",
			meta: {
				'title': '积分任务管理列表',
				'keepAlive': true,
			},
			name: "IntegralTaskList",
			component: () => import("../views/integral/task.vue")
		}, {
			path: "/integral/exchange-logs",
			meta: {
				'title': '积分兑换记录',
				'keepAlive': true,
			},
			name: "IntegralExchangeLogs",
			component: () => import("../views/integral/exchange.vue")
		}, {
			path: "/integral/datas",
			meta: {
				'title': '积分库',
				'keepAlive': true,
			},
			name: "IntegralData",
			component: () => import("../views/integral/data.vue")
		}, {
			path: "/shop/goodslist?type=8",
			meta: {
				'title': '商品管理',
				'keepAlive': true,
			},
			name: "IntegralGoodsList",
			component: () => import("../views/shops/goodsList.vue")
		}, {
			path: "/subaruclub/clubstiactiveapprovelist",
			meta: {
				'title': 'STI宠粉活动审核',
				'keepAlive': true,
			},
			name: "ClubStiActiveApproveList",
			component: () => import("../views/subaruclub/clubStiActiveApproveList.vue")
		},
		{
			path: "/subaruclub/clubgxractiveapprovelist",
			meta: {
				'title': '置换增购补贴活动审核',
				'keepAlive': false,
			},
			name: "ClubGxrActiveApproveList",
			component: () => import("../views/subaruclub/clubGxrActiveApproveList.vue")
		},
		{
			path: "/subaruclub/clubshopgoodslist",
			meta: {
				'title': '车友会商品列表',
				'keepAlive': true,
			},
			name: "ClubShopGoodsList",
			component: () => import("../views/subaruclub/clubShopGoodsList.vue")
		}, {
			path: "/subaruclub/clubshoporderlist",
			meta: {
				'title': '车友会订单列表',
				'keepAlive': true,
			},
			name: "ClubShopOrderList",
			component: () => import("../views/subaruclub/clubShopOrderList.vue")
		}, {
			path: "/subaruclub/testdriveorderlist",
			meta: {
				'title': '试驾奖品核销列表',
				'keepAlive': true,
			},
			name: "TestDriveOrderList",
			component: () => import("../views/subaruclub/testDriveOrderList.vue")
		}, {
			path: "/subaruclub/clubcarsauthlist",
			meta: {
				'title': '车友会车主认证列表',
				'keepAlive': false,
			},
			name: "ClubCarsAuthList",
			component: () => import("../views/subaruclub/clubCarsAuthList.vue")
		},
		{
			path: "/subaruclub/clubrankinglist",
			meta: {
				'title': '车友会排行榜',
				'keepAlive': false,
			},
			name: "ClubRankingList",
			component: () => import("../views/subaruclub/clubRankingList.vue")
		},
		{
			path: "/lexus/activeapprovelist",
			meta: {
				'title': '凌志范儿活动管理',
				'keepAlive': true,
			},
			name: "LexusActiveApproveList",
			component: () => import("../views/lexus/activeapproveList.vue")
		},
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js